//old import { formatDate, useOrgStyles } from "./orgUi";
import { LICENSE_TYPE_LABEL, formatDate, useOrgStyles } from "./orgUi";
import { licenseParts } from "../../pages/org/OrgLicenses";

const money = (n) => `$${Number(n || 0).toFixed(2)}`;
const per = (billingMode) => (billingMode === "yearly" ? "a year" : "a month");

/**
 * On the Overview: licenses Pono Pilot set up that are waiting for the
 * org to pay, and the day to pay by (Alicia, Oct 2: an expiring-soon indicator
 * on the dashboard; Sep 4: what the paying admin must do stays in sight), in the
 * Overview's yellow banner, until they're paid, declined or the day is over.
 * Said the Licenses page's way: "25 more student licenses ... ($499.00 a year),
 * 50 in all (25 free + 25 paid)", so the price isn't read as buying only those 25.
 */
export default function LicensePaymentBanner({ org, requests, onOpen }) {
    const s = useOrgStyles();
    const waiting = requests.filter((r) => r.Status === "approved" && r.PayBy && !r.PayByPassed && !r.QuoteChanged);
    // what the org has once they're paid, as the Licenses page counts it: its free (or included) licenses, the ones
    // added outside a plan, and these
    const base = (kind) => Number((kind === "coach" ? org?.CoachLicenseLimit : org?.StudentLicenseLimit) || 0);
    const added = (kind) => requests.filter((x) => x.LicenseType === kind && x.Status === "active" && !x.AutoRenews)
        .reduce((n, x) => n + Number(x.Quantity || 0), 0);
    return waiting.map((r) => {
        const priced = Number(r.TotalAmount) > 0;
        const qty = Number(r.Quantity);
        return (
            <div key={r.RequestID} role="status"
                 className={`flex flex-col gap-3 rounded-2xl border p-4 text-sm sm:flex-row sm:items-center sm:justify-between ${s.dark ? "border-amber-800 bg-amber-900/20" : "border-amber-200 bg-amber-50"}`}>
                <p className={s.text}>
                    {/* old <strong>{r.Quantity} more {r.LicenseType} licenses</strong> */}
                    <strong>{r.Quantity} more {LICENSE_TYPE_LABEL[r.LicenseType]} licenses</strong>
                    {r.AddsToPlan
                        ? (priced ? ` are waiting to be added to your plan (+${money(r.TotalAmount)} ${per(r.BillingMode)}).` : " are waiting to be added to your plan at no extra cost.")
                        : <> are waiting for payment ({money(r.TotalAmount)} {per(r.BillingMode)}), <strong>{base(r.LicenseType) + added(r.LicenseType) + qty}</strong> in all
                            ({licenseParts(org?.OrgType, base(r.LicenseType), added(r.LicenseType), qty)}).</>}
                    {" "}{priced ? "Pay" : "Add them"} by <strong>{formatDate(r.PayBy)}</strong>.
                </p>
                <button type="button" className={`${s.btnPrimary} flex-shrink-0`} onClick={onOpen}>{priced ? "Review and pay" : "Review and add"}</button>
            </div>
        );
    });
}
